// app/components/Plugins/Automations/core/BaseNode.ts

import { NodeData, AutomationNode } from '../types';
import { ExecutionContext, NodeProtocol, SerializedNode, ValidationResult } from './protocols';

/**
 * Base implementation of the NodeProtocol
 * Provides common functionality for all node types
 */
export abstract class BaseNode implements NodeProtocol {
  id: string;
  type: string;
  position: { x: number; y: number };
  data: NodeData;

  constructor(node: AutomationNode) {
    this.id = node.id;
    this.type = node.type || ''; // Ensure type is always a string
    this.position = node.position;
    this.data = node.data;
  }

  /**
   * Process the node in the execution context
   * This method should be implemented by each node type
   */
  abstract process(context: ExecutionContext): Promise<boolean>;

  /**
   * Validate the node configuration
   * Default implementation checks for required fields
   */
  validate(): ValidationResult {
    const errors: string[] = [];
    
    if (!this.id) {
      errors.push('Node ID is required');
    }
    
    if (!this.type) {
      errors.push('Node type is required');
    }
    
    return {
      valid: errors.length === 0,
      errors
    };
  }

  /**
   * Serialize the node for storage
   */
  serialize(): SerializedNode {
    return {
      id: this.id,
      type: this.type,
      position: this.position,
      data: this.data
    };
  }
}